( function () {
    'use strict';
    e.util = {};
    // Open all links tagged with 'newwindow' in a new window
    e.util.openLinksInNewWindow = function () {
        var jLinks = jQuery( 'a.newwindow' );
        if ( jLinks.length > 0 ) {
            jLinks.on( 'click', function ( event ) {
                event.preventDefault();
                window.open( this.href );
            } );
        }
    };
    // Vis overlay der passer p&aring; gridet
    e.util.toggleGridOverlay = function () {
        jQuery( 'a[href$="toggle-grid-overlay"]' ).on( 'click', function ( event ) {
            event.preventDefault();
            var jGrid = jQuery( '#e-grid' );
            jGrid.toggle().closest( '.e-content' ).css( {
                position: jGrid.is( ':visible' ) ? 'relative' : 'static'
            } );
        } );
    };
    // Tilføj produkter og nyheder til breadcrumbs
    e.util.appendPageToBreadcrumb = function () {
        var jBreadcrumb = jQuery( '.breadcrumb' ).filter( ':visible' );
        if ( jBreadcrumb.is( '.visible-phone' ) ) {
            jBreadcrumb.find( 'li:last-child' ).text( jQuery( '.js-e-breadcrumb-link-text' ).text() );
        }
        else {
            var jBreadcrumbNewItem = jBreadcrumb.find( 'li' ).last().clone();
            if ( jBreadcrumbNewItem.find( '.divider' ).length === 0 ) {
                jBreadcrumbNewItem.prepend( '<span class="divider">/</span>' );
            }
            jBreadcrumbNewItem.find( 'a' ).attr( 'href', jQuery( '.js-e-breadcrumb-link-url' ).text() ).find( 'span' ).text( jQuery( '.js-e-breadcrumb-link-text' ).text() );
            jBreadcrumb.append( jBreadcrumbNewItem );
        }
    };
    //Add animation entry to images and/or paragraphs
    e.util.animateParagraphEntry = function () {
        var jParagraphsToAnimate = jQuery( '.animate' ).not( '.e-ecom-grid li, .e-productlist li' ).removeClass( 'animate' ).closest( '[class*="span"]' ).addClass( 'animate' ).add( '.e-ecom-grid li.animate, .e-productlist li.animate' ),
            isAboutToFire = false,
            eventThreshold = ( ( navigator.userAgent.toLowerCase().indexOf( 'mac os' ) !== -1 ) ? 10 : 100 );
        e.constant.jWindow.on( 'scroll resize', function () {
            if ( isAboutToFire ) {
                clearTimeout( isAboutToFire );
            }
            isAboutToFire = setTimeout( function () {
                var animateIndex = 0;
                jParagraphsToAnimate.each( function ( index ) {
                    var jThis = jParagraphsToAnimate.eq( index );
                    if ( jThis.is( '.animate-triggered' ) === false && e.util.isInViewport( jThis ) === true ) {
                        jThis.addClass( 'animate-triggered' );
                        setTimeout( function () {
                            jThis.addClass( 'fadeIn' ).addClass( 'animate-show' );
                            jParagraphsToAnimate.splice( jParagraphsToAnimate.index( jThis ), 1 );
                        }, animateIndex * 100 );
                        animateIndex++;
                    }
                } );
            }, isAboutToFire ? eventThreshold : 1 );
        } ).triggerHandler( 'scroll' );
    };
    e.util.isInViewport = function ( jElm ) {
        var viewportTop = e.constant.jWindow.scrollTop(),
            viewportBottom = viewportTop + e.constant.jWindow.height(),
            elmTop = jElm.offset().top,
            elmBottom = elmTop + jElm.height();
        return ( elmTop <= viewportBottom && elmBottom >= viewportTop );
    };
    e.util.formFieldsResetToDefault = function ( jFields ) {
        jFields.filter( 'input[type="text"],input[type="hidden"],input[type="password"],textarea' ).each( function () {
            this.value = this.defaultValue;
        } );
        jFields.filter( 'input[type="radio"],input[type="checkbox"]' ).each( function () {
            this.checked = this.defaultChecked;
        } );
        jFields.filter( 'select' ).not( '[multiple]' ).find( 'option[selected]' ).each( function () {
            this.parentNode.selectedIndex = this.index;
        } );
        jFields.filter( 'select' ).filter( '[multiple]' ).find( 'option' ).each( function () {
            this.selected = this.defaultSelected;
        } );
        jFields.each( function () {
            //jQuery( this ).triggerHandler( 'change' );
        } );
    };
    // Konstruer et object indeholdende alle querystringens parametre
    e.util.param = ( function () {
        var vars = [],
            hash,
            hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
        for ( var i = 0; i < hashes.length; i++ ) {
            hash = hashes[ i ].split( '=' );
            vars.push( hash[ 0 ] );
            vars[ hash[ 0 ] ] = decodeURIComponent( hash[ 1 ] ).replace( /\+/g, ' ' );
        }
        return vars;
    } )();
    //konverter rgb(a) værdier til hex
    e.util.rgb2hex = function ( rgb ) {
        function hex( x ) {
            return ( '0' + parseInt( x ).toString( 16 ) ).slice( -2 );
        }
        if ( rgb.search( 'rgb' ) === -1 ) {
            return rgb;
        }
        else {
            rgb = rgb.match( /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/ );
            return '#' + hex( rgb[ 1 ] ) + hex( rgb[ 2 ] ) + hex( rgb[ 3 ] );
        }
    };
    e.util.formatNumber = function formatNumber( number ) {
        //TODO: lav funktion der kan afrunde matematisk
        //http://www.sacah.net/2011/01/javascript-format-number-price-amount.html
        number = String( parseFloat( Math.round( number * 100 ) / 100 ).toFixed( 2 ) ).replace( /[^\d\.\-]/g, '' ).replace( /(\.\d{2})[\W\w]+/g, '$1' ).split( '' ).reverse().join( '' ).replace( /(\d{3})/g, '$1.' ).split( '' ).reverse().join( '' ).replace( /^([\-]{0,1})\./, '$1' ).replace( /\.(\d\d)$/, ',' + '$1' ).replace( /\.(\d)$/, ',' + '$1' + '0' ).replace( /\.$/, ',00' );
        if ( e.config.pageLanguage !== 'da' ) {
            number = number.replace( /\./g, '{integer}' );
            number = number.replace( /\,/g, '{decimal}' );
            number = number.replace( new RegExp( '{integer}', 'g' ), e.config.IntergerSeparator );
            number = number.replace( new RegExp( '{decimal}', 'g' ), e.config.DecimalSeparator );
        }
        return number;
    };
    e.util.formatNumberToJavascript = function ( number ) {
        return parseFloat( String( number ).replace( e.config.regExpIntergerSeparator, '' ).replace( e.config.regExpDecimalSeparator, '.' ) );
    };
    // Smooth scrolling
    e.util.scroll = {};
    e.util.scroll.init = function () {
        e.util.scroll.isAnimating = false;
        e.util.scroll.loadEasing();
        e.util.scroll.toAnchor();
    };
    e.util.scroll.loadEasing = function () {
        e.util.scroll.easing = 'swing';
        jQuery.ajax( {
            url: '//cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js',
            dataType: 'script',
            timeout: 500,
            cache: true
        } ).success( function () {
            e.util.scroll.easing = 'easeInOutExpo';
        } );
    };
    e.util.scroll.toAnchor = function () {
        jQuery( 'a[href*="#"]' ).on( 'click', function ( event ) {
            if ( location.pathname.replace( /^\//, /"\// ) === this.pathname.replace( /^\//, /"\// ) && location.hostname === this.hostname ) {
                var target = this.hash,
                    jTarget = ( target === '#top' ) ? e.constant.jHtml : jQuery( 'a[name="' + target.substr( 1 ) + '"]' );
                event.preventDefault();
                e.util.scroll.toElement( jTarget, 0, true, true );
            }
        } );
        if ( location.hash !== '' ) {
            e.util.scroll.toElement( jQuery( 'a[name="' + location.hash.substr( 1 ) + '"]' ), 0, true, true );
        }
    };
    e.util.scroll.toElement = function ( jTarget ) {
        jTarget = jTarget.first();
        if ( jTarget.length === 1 ) {
            var extraOffset = arguments[ 1 ] || 0,
                allowNegative = arguments[ 2 ] || false,
                allowInViewport = arguments[ 3 ] || false,
                systemAdjustment = 0,
                jStickyNav = jQuery( '.js-e-nav-sticky-wrapper' ),
                scrollTarget = 0;
            systemAdjustment = parseInt( jTarget.css( 'font-size' ), 10 );
            if ( jStickyNav.length > 0 ) {
                systemAdjustment += jStickyNav.outerHeight();
            }
            if ( extraOffset > 0 ) {
                systemAdjustment = 0;
            }
            scrollTarget = jTarget.offset().top - systemAdjustment + extraOffset;
            //console.log( e.util.scroll.isAnimating === false, ( e.util.isInViewport( jTarget ) === false || allowInViewport === true) , ( scrollTarget > e.constant.jWindow.scrollTop() || allowNegative === true ) );
            if ( ( e.util.isInViewport( jTarget ) === false || allowInViewport === true ) && ( scrollTarget > e.constant.jWindow.scrollTop() || allowNegative === true ) ) {
                e.util.scroll.toPosition( scrollTarget );
            }
        }
    };
    e.util.scroll.toPosition = function ( scrollTarget ) {
        scrollTarget = parseFloat( scrollTarget );
        if ( e.util.scroll.isAnimating === false ) {
            e.util.scroll.isAnimating = true;
            jQuery( 'html,body' ).animate( {
                scrollTop: scrollTarget
            }, e.settings.scrollAnimationSpeed, e.util.scroll.easing, function () {
                e.util.scroll.isAnimating = false;
            } );
        }
    };
    e.util.validateEmail = function ( emailAddress ) {
        var validEmailRegExp = new RegExp( /[a-zæøå0-9_\+\-]+(\.[a-zæøå0-9_\+\-]+)*@[a-zæøå0-9\-]+(\.[a-zæøå0-9\-]+)*\.([a-z]{2,6})$/i );
        return validEmailRegExp.test( emailAddress );
    };
}() );
